import {
  withState,
  patchState,
  withMethods,
  signalStoreFeature,
  WritableStateSource,
} from '@ngrx/signals';

export function withCustomCallState<Name extends string>(name: Name) {
  type State = Record<`${Name}isLoading`, boolean> &
    Record<`${Name}isSuccess`, boolean> &
    Record<`${Name}hasError`, string | null>;

  type Methods = Record<`_${Name}SetLoading`, () => void> &
    Record<`_${Name}SetSuccess`, () => void> &
    Record<`_${Name}SetError`, (error: string | null) => void> &
    Record<`_${Name}ResetState`, () => void>;

  const baseState = {
    [`${name}isLoading`]: false,
    [`${name}isSuccess`]: false,
    [`${name}hasError`]: null as string | null,
  };

  return signalStoreFeature(
    withState(baseState as State),

    withMethods(
      (store): Methods =>
        ({
          [`_${name}SetLoading`]: () => {
            patchState(
              store as WritableStateSource<State>,
              {
                [`${name}isLoading`]: true,
                [`${name}isSuccess`]: false,
                [`${name}hasError`]: null,
              } as Partial<State>,
            );
          },

          [`_${name}SetSuccess`]: () => {
            patchState(
              store as WritableStateSource<State>,
              {
                [`${name}isLoading`]: false,
                [`${name}isSuccess`]: true,
                [`${name}hasError`]: null,
              } as Partial<State>,
            );
          },

          [`_${name}SetError`]: (error: string | null) => {
            patchState(
              store as WritableStateSource<State>,
              {
                [`${name}isLoading`]: false,
                [`${name}isSuccess`]: false,
                [`${name}hasError`]: error,
              } as Partial<State>,
            );
          },

          [`_${name}ResetState`]: () => {
            patchState(
              store as WritableStateSource<State>,
              {
                [`${name}isLoading`]: false,
                [`${name}isSuccess`]: false,
                [`${name}hasError`]: null,
              } as Partial<State>,
            );
          },
        }) as Methods,
    ),
  );
}
